import store from '@/store'

/**
 * 判断是否有指定权限编码
 * 权限来源于 menu 模块的 getPermissionSet
 * @param permissionCode 权限编码
 * @returns 有权限返回 true
 */
export function hasPermission(permissionCode: string): boolean {
  const permissions = store.getters['menu/getPermissionSet']
  return permissions && permissions.has(permissionCode)
}
